var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.99992C14.3416 6.99992 15.8333 5.50825 15.8333 3.66659C15.8333 1.82492 14.3416 0.333252 12.5 0.333252C10.6583 0.333252 9.16665 1.82492 9.16665 3.66659C9.16665 5.50825 10.6583 6.99992 12.5 6.99992ZM12.5 1.99992C13.4166 1.99992 14.1666 2.74992 14.1666 3.66659C14.1666 4.58325 13.4166 5.33325 12.5 5.33325C11.5833 5.33325 10.8333 4.58325 10.8333 3.66659C10.8333 2.74992 11.5833 1.99992 12.5 1.99992ZM12.5 8.66658C10.275 8.66658 5.83331 9.78325 5.83331 11.9999V13.6666H19.1666V11.9999C19.1666 9.78325 14.725 8.66658 12.5 8.66658ZM7.49998 11.9999C7.68331 11.3999 10.2583 10.3333 12.5 10.3333C14.75 10.3333 17.3333 11.4083 17.5 11.9999H7.49998ZM4.99998 9.49992V6.99992H7.49998V5.33325H4.99998V2.83325H3.33331V5.33325H0.833313V6.99992H3.33331V9.49992H4.99998Z",
    fill: "#6271DD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddUser);
export default __webpack_public_path__ + "static/media/add-user.e861b3df99dbe4e5a0bce634ba98566a.svg";
export { ForwardRef as ReactComponent };